//TECH ICONS
import CssIcon from "../../assets/icons/tech/css3.svg";
import HtmlIcon from "../../assets/icons/tech/html5.svg";
import JavaScriptIcon from "../../assets/icons/tech/javascript.svg";
import ReactIcon from "../../assets/icons/tech/react.svg";
import ReduxIcon from "../../assets/icons/tech/redux.svg";
import SassIcon from "../../assets/icons/tech/sass.svg";

//TOOLS ICONS
import FigmaIcon from "../../assets/icons/tools/figma.svg";
import JestIcon from "../../assets/icons/tech/jest.svg"
import GitIcon from "../../assets/icons/tools/git.svg";
import GitHubIcon from "../../assets/icons/tools/github.svg";

//CONTACT ICONS
import LinkedInIcon from "../../assets/icons/contact/linkedin.svg";
import XIcon from "../../assets/icons/contact/x.svg";
import InstagramIcon from "../../assets/icons/contact/instagram.svg";
import FacebookIcon from "../../assets/icons/contact/facebook.svg";

const Icons = {
	technologies: [
		{ svg: CssIcon, altText: "Css icon" },
		{ svg: HtmlIcon, altText: "Html5 icon" },
		{ svg: JavaScriptIcon, altText: "Javascript icon" },
		{ svg: JestIcon, altText: "Jest icon" },
		{ svg: ReactIcon, altText: "React icon" },
		{ svg: ReduxIcon, altText: "Redux icon" },
		{ svg: SassIcon, altText: "Sass icon" },
	],
	tools: [
		{ svg: FigmaIcon, altText: "Figma icon" },
		{ svg: GitIcon, altText: "Git icon" },
	],
	contact: [
		{ svg: GitHubIcon, altText: "Github icon" },
		{ svg: LinkedInIcon, altText: "LinkedIn icon" },
		{ svg: XIcon, altText: "X icon" },
		{ svg: InstagramIcon, altText: "Instagram icon" },
		{ svg: FacebookIcon, altText: "Facebook icon" },
	],
};

export default Icons;
